export default __webpack_public_path__ + "static/media/HDTX_Pengumuman RUPS 2021.bab37d68.pdf";